<template>
  <div class="placeholder">
      <p>{{ msg}}</p>
  </div>
</template>

<script>
export default {
  name: 'DuncePlaceholder',
  props: {
    msg: String
  }
}
</script>

<style>
.placeholder {
  text-align: center;
  margin-top: 10rem;
  color: white;
  font-family: "Courier New", Courier, "Lucida Sans Typewriter", "Lucida Typewriter", monospace;
  font-size: 1.2rem;
}
</style>